function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "38",
  viewBox: "0 0 21 29",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "button/slider/projekte-copy-4",
  transform: "translate(-14 -10)",
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(-.334)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.498 16.547h-6.495l1.25-4.797a2.054 2.054 0 011.997-1.521c.942 0 1.764.626 1.997 1.521l1.25 4.797zm1.49 5.72h-9.476l.78-2.996h7.916l.78 2.996zm1.491 5.72H19.022l.056-.214.48-1.84.245-.943h10.895l.781 2.997zm3.81 7.994c0 1.18-.975 2.137-2.178 2.137H17.389c-1.202 0-2.177-.956-2.177-2.137 0-1.18.975-2.136 2.177-2.136h.106l.817-3.135h13.876l.817 3.135h.106c1.203 0 2.177.957 2.177 2.136z",
  id: "Combined-Shape"
}))))));